const compareCustomFilters = (a, b) => {
    // Easy preliminary check
    if (a.length !== b.length) {
        return true;
    }

    for (let i = 0; i < a.length; i += 1) {
        if (a[i].measure !== b[i].measure || a[i].operator !== b[i].operator || a[i].value !== b[i].value) {
            return true;
        }
    }
    return false;
};

const compareFilterValues = (valuesA, valuesB) => {
    return Object.keys(valuesA).some((key) => {
        if (key === 'customFilters') {
            return compareCustomFilters(valuesA[key], valuesB[key]);
        }
        return valuesA[key] !== valuesB[key];
    });
};

const compareFilterStates = (stateA, stateB) => {
    // Only update if the filter values have changed
    const areFiltersDifferent = compareFilterValues(stateA.values, stateB.values);
    return stateA.isVisible !== stateB.isVisible || areFiltersDifferent;
};

export { compareFilterValues, compareFilterStates };
